import React from 'react'
import { FormGroup, Button, Spinner } from "reactstrap"
import { connect } from "react-redux"

const ButtonField = (props) => {
  const { form } = props

  return (
    <FormGroup>
      <Button.Ripple
        type="submit"
        color="primary"
        disabled={form.loading}
        block
      >
        {
          form.loading
            ? <Spinner color="white" size="sm" />
            : <p className="m-0">{props.text}</p>
        }
      </Button.Ripple>
    </FormGroup>
  )
}

const mapStateToProps = state => {
  return {
    form: state.form
  }
}

export default connect(mapStateToProps)(ButtonField)
